<template>
  <v-dialog v-model="$store.state.socialEventDialogVisible" max-width="90vw" height="80vh" v-if="$store.state.socialEventDialogVisible">
    <v-card rounded="xxl" class="bg">
      <v-img
          :src="$store.state.socialEventData.location_id.pic_url"
          lazy-src="~@/assets/alberta-2297204_1920.jpg"
          height="120px"
          v-if="$store.state.socialEventData.location_id.pic_url"
      ></v-img>
      <v-card-title class="headline px-2">{{ $store.state.socialEventData.short_title }}</v-card-title>
      <v-card-subtitle class="my-1 py-0">
        <v-icon small>mdi-map-marker</v-icon> {{ formattedLocationName($store.state.socialEventData.location_id.name) }}
      </v-card-subtitle>
      <v-card-subtitle class="my-1 py-0" v-if="$store.state.socialEventData.timeframe">
        <v-icon small>mdi-calendar-clock</v-icon> {{ $store.state.socialEventData.timeframe }}
      </v-card-subtitle>
      <v-card-subtitle class="my-1 py-0" v-if="$store.state.socialEventData.user_id" @click="openProfileCard($store.state.socialEventData.user_id?.id)">
        <v-icon small>mdi-account</v-icon>By {{ $store.state.socialEventData.user_id.full_name }}
      </v-card-subtitle>
      <v-card-text class="px-3">
        <v-divider class="mb-3"></v-divider>
        <div>
          <div v-if="readMore" class="formatted-content" v-html="linkedText($store.state.socialEventData.content)"></div>
          <div class="formatted-content" v-else>{{ truncatedContent }}</div>
          <v-btn text style="text-transform: capitalize" @click="toggleReadMore" v-if="$store.state.socialEventData.content.length > 250">{{ readMore ? 'Read Less' : 'Read More' }}</v-btn>
        </div>


      </v-card-text>
      <v-card-actions>
        <v-btn v-if="$store.state.socialEventData.user_id && $store.state.socialEventData.url" text style="text-transform: capitalize" :href="$store.state.socialEventData.url" target="_blank" color="blue">Learn More</v-btn>
        <v-btn v-else-if="$store.state.socialEventData.url" text style="text-transform: capitalize" :href="$store.state.socialEventData.url" target="_blank" color="blue">View Post</v-btn>
        <v-spacer></v-spacer>
        <v-btn rounded color="primary" small style="text-transform: capitalize" @click="this.closePostDialog">Close</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  name: 'SocialEventDialog',
  data() {
    return {
      readMore: false,
    };
  },
  computed: {
    truncatedContent() {
      console.log(store.state.socialEventData.content)
      return store.state.socialEventData.content.length > 250 ? store.state.socialEventData.content.substring(0, 250) + '...' : store.state.socialEventData.content;
    },
  },
  methods: {
    async openProfileCard(user_id) {
      await store.dispatch('getProfileCardData', user_id)
      store.commit('profileDialogOn')
    },
    linkedText(originalText) {
      // Simple regex to match URLs
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return originalText.replace(urlRegex, function(url) {
        return `<a style="color: #2196F3!important;" href="${url}" target="_blank">${url}</a>`;
      });
    },
    formattedLocationName(locationName) {
      let locationNameArray = locationName.split(", ");
      if (locationNameArray.length === 2) {
        if (locationNameArray[0] === locationNameArray[1]) {
          return locationNameArray[0]
        } else {
          return locationName
        }
      } else {
        return locationName
      }
    },
    openSocialEventDialog(itemData) {
      console.log(itemData)
      store.commit('setSocialEvent', itemData)
    },
    toggleReadMore() {
      this.readMore = !this.readMore;
    },
    closePostDialog() {
      this.readMore = false;
      store.commit('eventDialogOff')
    },
  },


};
</script>

<style scoped>
.headline{
  text-transform: capitalize;
  word-break: break-word;
}
.formatted-content {
  white-space: pre-wrap; /* Or 'pre-line' based on your requirement */
  word-wrap: break-word; /* IE */
}

.bg{
  background-color: #A9C9FF;
  background-image: linear-gradient(180deg, #A9C9FF 0%, #FFBBEC 100%);
}


</style>